import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CommonService } from '../../../_services/common.service';
import { CreateChargingProfileRequest } from '../../../modules/ocpp/models/CreateChargingProfileRequest';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ChargingProfileService {
    constructor(private http: HttpClient, private commonService: CommonService) {

    }

    public createChargingProfile(chargingProfile: any, createdBy) {
        let headers = { headers: { 'createdBy': String(createdBy) } };
        if (chargingProfile.validFrom) {
            let from = chargingProfile.validFrom._d;
            if (from)
                chargingProfile.validFrom = (new Date(from.getFullYear(), from.getMonth(), from.getDate() + 1)).toISOString();
        }
        if (chargingProfile.validTo) {
            let to = chargingProfile.validTo._d;
            if (to)
                chargingProfile.validTo = (new Date(to.getFullYear(), to.getMonth(), to.getDate() + 1)).toISOString();
        }
        if (chargingProfile.startSchedule) {
            let start = chargingProfile.startSchedule._d;
            if (start)
                chargingProfile.startSchedule = (new Date(start.getFullYear(), start.getMonth(), start.getDate() + 1)).toISOString();
        }
        return this.http.post(`${environment.API_BASE_PATH}/charging-profiles`, chargingProfile, headers);
    }

    getAllChargingProfiles(index, rows, column, direction, search, createdBy) {
        let headers = { headers: { 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction), 'search': String(search), 'createdBy': String(createdBy) } };
        return this.http.get(`${environment.API_BASE_PATH}/charging-profiles`,headers);
    }

    getTotalChargingProfiles(createdBy){
        let headers = { headers: { 'startingIndex': "1", 'maxRows':"1000",  'createdBy': String(createdBy)} };
        return this.http.get(`${environment.API_BASE_PATH}/charging-profiles`,headers);
    }

    getChargingProfileDetails(id, createdBy){
        let headers = { headers: { 'createdBy': String(createdBy) } };
        return this.http.get(`${environment.API_BASE_PATH}/charging-profiles/${id}/details`, headers);
    }
}
